import controller from './orderAndDelivery.controller';
import template from './orderAndDelivery.html';

const OrderAndDeliveryDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default OrderAndDeliveryDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndDelivery/orderAndDelivery.component.js
 **/